/**
 * Serviceplan MAKEOS
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ReplyData { 
    replyComment?: string;
    imageData?: Array<string>;
    createdAt?: string;
    createdBy?: string;
}

